import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { Header } from './header';
import { Content } from './content';
import { Footer } from './footer';

export const DisplayQueue = props => (
  <div className="notification-queue-display">
    <Header
      {...props.header}
      actionCallback={props.actionCallback}
      isUINext={props.isUINext}
      i18n={props.i18n}
    />
    <Content
      notifications={props.notifications}
      actionCallback={props.actionCallback}
      isUINext={props.isUINext}
      i18n={props.i18n}
      logger={props.logger}
      logContent={props.logContent}
    />
    <Footer
      {...props.footer}
      isUINext={props.isUINext}
    />
  </div>
);

DisplayQueue.propTypes = {
  header: PropTypes.instanceOf(Object).isRequired,
  notifications: PropTypes.arrayOf(PropTypes.instanceOf(Object)).isRequired,
  actionCallback: PropTypes.func.isRequired,
  footer: PropTypes.instanceOf(Object).isRequired,
  isUINext: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    trace: PropTypes.func,
  }),
  logContent: PropTypes.func,
};

DisplayQueue.defaultProps = {
  logger: {
    trace: _.noop,
  },
  logContent: _.noop,
};

